import React from 'react';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import SelectAvailableScreensNew from './SelectAvailableScreensNew';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import ETVTable from '../tools/ETVTable';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Switch from '@mui/material/Switch';
import * as ETVConstants from '../ETVConstants';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import ETVActionButton from '../tools/ETVActionButton';
import ETVMessagePopup from '../tools/ETVMessagePopup';
import ETVPage from '../tools/ETVPage';
import ETVPopup from '../tools/ETVPopup';

class MessagingAdapter extends React.Component {

    constructor(props) {
      super(props);
      this.selectedScreens = this.selectedScreens.bind(this);
      this.closeScreenSelection = this.closeScreenSelection.bind(this);
			this.resultListener = this.resultListener.bind(this);
      this.resultListenerConfig = this.resultListenerConfig.bind(this);
      this.resultListenerContact = this.resultListenerContact.bind(this);
    }

    state = {
      selected_channel:0,
      default_playtime:10,
      default_keeptime_days:2,
      need_approval:true,
      show_image_overlay:false,
      device_ids:[],
      accept_movies:false,
      accept_texts:false,
      contacts:[],
      contactsLoaded:false,
      configLoaded:false,
      window:'',
      spinning: false,
      info_type: '',
      contact_name_error: false,
      info_message:'',
      info_title:'',
      new_contact_name:'',
      new_contact_id:'',
      contact_id_error:false,
    }

    componentDidUpdate() {
      if(!this.state.contactsLoaded) {
        this.loadContacts();
      }else if(!this.state.configLoaded) {
        this.loadConfig();
      }
		}

    componentDidMount() {
      this.loadContacts();
      this.loadConfig();
    }

    loadConfig() {
			var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
			var url = ETVConstants.getServerBase()+"/messaging?user_id="+this.props.user_id+"&action=get_config&message_type=email";
      fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            //console.log("--------------------"+JSON.stringify(result));
            this.setState({
              accept_movies: result.config.accept_movies,
              accept_texts: result.config.accept_texts,
              selected_channel:result.config.channel,
              default_playtime:result.config.default_playtime,
              default_keeptime_days:result.config.default_keeptime_days,
              need_approval:result.config.need_approval,
              show_image_overlay:result.config.show_image_overlay,
              device_ids:result.config.device_ids?result.config.device_ids:[],
              configLoaded: true,
            });
          },
          (error) => {
            this.setState({
              config:{},
              configLoaded: false,
              error
            });
          }
        )
    }

    loadContacts() {
			var accessToken = localStorage.getItem("etv.access_token");
      var reqUserID = localStorage.getItem("etv.user_id");
			var url = ETVConstants.getServerBase()+"/messaging?user_id="+this.props.user_id+"&action=get_contacts&message_type=email";
      fetch(url,{ headers: { 'user_id':reqUserID, 'access_token': accessToken }})
        .then(res => res.json())
        .then(
          (result) => {
            //console.log(JSON.stringify(result));
            this.setState({
              contacts: result,
              contactsLoaded: true,
            });
          },
          (error) => {
            this.setState({
              contacts:[],
              contactsLoaded: false,
              error
            });
          }
        )
    }

    selectedScreens(screenIDs) {
      //console.log("selected deviceIDs="+screenIDs);
      this.showWindow('select_screens_div',false);
      this.setState({device_ids:screenIDs});
    }

    closeScreenSelection() {
      this.showWindow('select_screens_div',false);
    }

    showWindow(divID, show) {
      show?this.setState({window:divID}):this.setState({window:''});
    }

    showInfoMessage(title, msg, isSpinning) {
      this.setState({ window: 'message_div', info_type: isSpinning ? 'progress' : 'info', info_title: title, info_message: msg, spinning: !!isSpinning });
    }
    showSuccessMessage(title, msg) {
      this.setState({ window: 'message_div', info_type: 'success', info_title: title, info_message: msg, spinning: false });
    }
    showErrorMessage(title, msg) {
      this.setState({ window: 'message_div', info_type: 'error', info_title: title, info_message: msg, spinning: false });
    }
    closeInfoMessage() {
      this.setState({ window: '', info_type: '', info_title: '', info_message: undefined, spinning: false });
    }

    deleteContact(contactID) {
      	var url = ETVConstants.getServerBase()+"/messaging?user_id="+this.props.user_id+"&action=delete_contact&message_type=email&contact_id="+encodeURIComponent(contactID);
        ETVConstants.sendCMDToServerListener(url,this.resultListener);
    }

    resultListener(val) {
			this.setState({contactsLoaded:false});
		}

    resultListenerConfig(res) {
      //console.log("res="+JSON.stringify(res));
      if(res.result) {
        this.showSuccessMessage(ETVConstants.trans("config_updated"));
      }else{
        this.showErrorMessage("config updated failed. Reason="+res.reason);
      }
    }

    resultListenerContact(res) {
      //console.log("res="+JSON.stringify(res));
      if(res.result) {
        //this.showInfoMessage("contact added");
        this.setState({contactsLoaded:false,window:'',new_contact_id:'',new_contact_name:''});
      }else{
          this.showErrorMessage(ETVConstants.trans(res.reason));
      }
    }

    saveNewContact() {
      if(!this.checkAddContact(this.state.new_contact_id,this.state.new_contact_name)) {
        return;
      }
      var userID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/messaging?user_id="+userID+"&action=insert_contact&message_type=email";
      url += "&contact_id="+encodeURIComponent(this.state.new_contact_id.trim());
      url += "&contact_name="+encodeURIComponent(this.state.new_contact_name);
      ETVConstants.sendCMDToServerListener(url,this.resultListenerContact);
    }

    saveSettings() {
      var userID = localStorage.getItem("etv.user_id");
      var url = ETVConstants.getServerBase()+"/messaging?user_id="+userID+"&action=update_config&message_type=email";
      url += "&accept_movies="+this.state.accept_movies;
      url += "&accept_texts="+this.state.accept_texts;
      url += "&channel="+this.state.selected_channel;
      url += "&default_playtime="+this.state.default_playtime;
      url += "&default_keeptime_days="+this.state.default_keeptime_days;
      url += "&need_approval="+this.state.need_approval;
      url += "&show_image_overlay="+this.state.show_image_overlay;
      if(this.state.device_ids && this.state.device_ids.length>0) {
        for(var i=0; i<this.state.device_ids.length; i++) {
          url += "&device_id="+this.state.device_ids[i];
        }
      }
      ETVConstants.sendCMDToServerListener(url,this.resultListenerConfig);
    }

    showAddContact() {
      this.showWindow("add_contact_div",true);
    }

    checkAddContact(email, name) {
      const isEmail = this.isValidEmail(email);
      const hasName = !!name && name.trim().length > 0;

      if (isEmail && hasName) {
        this.setState({
          new_contact_id: email.trim(),
          new_contact_name: name,
          contact_id_error: false,
          contact_name_error: false,
        });
        return true;
      } else {
        this.setState({
          contact_id_error: !isEmail,
          contact_name_error: !hasName,
        });
        return false;
      }
    }

    isValidEmail(email) {
      if (!email) return false;
      const v = String(email).trim();
      // simple + practical email check (not perfect RFC, but good UI validation)
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
    }

    render() {

      const contactsData= [
          { title: ETVConstants.trans("contact"), field: 'contact_id' },
          { title: ETVConstants.trans("contact_name"), field: 'contact_name' },
          { title: ETVConstants.trans("delete"), field: 'select_layout', render: rowData => <IconButton size='small' color='error' onClick={()=>this.deleteContact(rowData.contact_id)}><DeleteIcon/></IconButton>},
      ];

      return (
        <ETVPage
          width="standard"
          icon={<EmailOutlinedIcon fontSize="large" />}
          title={ETVConstants.trans('messaging_configuration')}
          description={ETVConstants.trans('messaging_configuration_explanation')}
          loading={!this.state.contactsLoaded || !this.state.configLoaded || this.state.spinning}
          bottomActions={
            <ETVActionButton
              action="save"
              label={ETVConstants.trans('save_settings')}
              onClick={()=>this.saveSettings()}
            />
          }
        >
          <TableContainer sx={{maxWidth:760,border:'1px solid',borderColor:'divider',borderRadius:2,overflow:'hidden'}}>
                  <Table>
                    <TableHead>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell>
                            <Typography component={'span'} variant="body1">
                                <Box fontWeight='bold' display='inline'>{ETVConstants.trans("select_screens")}</Box>
                            </Typography>
                            <Typography variant="body2">{ETVConstants.trans("messaging_select_screen_help")}</Typography>
                        </TableCell>
                        <TableCell>
                          <Button color='primary' size='small' variant='outlined' onClick={()=>{this.showWindow('select_screens_div',true)}}>{ETVConstants.trans("select_screens")} ({this.state.device_ids.length})</Button>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("channel")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("messaging_channel_help")}</Typography>
                        </TableCell>
                        <TableCell>
                            <FormControl>
                               <InputLabel component="legend">{ETVConstants.trans("channel")}</InputLabel>
                               <Select
                                   label={ETVConstants.trans("channel")}
                                   id="chosen_channel"
                                   fullWidth
                                   value={this.state.selected_channel}
                                   onChange={(e)=>{this.setState({selected_channel:e.target.value})}}>
                                   <MenuItem value={0}>Channel 0</MenuItem>
                                   <MenuItem value={1}>Channel 1</MenuItem>
                                   <MenuItem value={2}>Channel 2</MenuItem>
                                   <MenuItem value={3}>Channel 3</MenuItem>
                                   <MenuItem value={4}>Channel 4</MenuItem>
                               </Select>
                             </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("default_keeptime_days")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("default_keeptime_days_help")}</Typography>
                        </TableCell>
                        <TableCell>
                        <FormControl>
                           <InputLabel component="legend">{ETVConstants.trans("default_keeptime_days")}</InputLabel>
                           <Select
                               label={ETVConstants.trans("default_keeptime_days")}
                               id="default_keep_time_days"
                               style={{ width: 200}}
                               value={this.state.default_keeptime_days}
                               onChange={(e)=>{this.setState({default_keeptime_days:e.target.value})}}>
                               <MenuItem value={1}>{ETVConstants.trans("1_day")}</MenuItem>
                               <MenuItem value={2}>{ETVConstants.trans("2_days")}</MenuItem>
                               <MenuItem value={3}>{ETVConstants.trans("3_days")}</MenuItem>
                               <MenuItem value={4}>{ETVConstants.trans("4_days")}</MenuItem>
                               <MenuItem value={5}>{ETVConstants.trans("5_days")}</MenuItem>
                               <MenuItem value={6}>{ETVConstants.trans("6_days")}</MenuItem>
                               <MenuItem value={7}>{ETVConstants.trans("1_week")}</MenuItem>
                               <MenuItem value={14}>{ETVConstants.trans("2_weeks")}</MenuItem>
                               <MenuItem value={31}>{ETVConstants.trans("1_month")}</MenuItem>
                               <MenuItem value={10000}>{ETVConstants.trans("never")}</MenuItem>
                           </Select>
                         </FormControl>
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("default_playtime")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("default_playtime_help")}</Typography>
                        </TableCell>
                        <TableCell>
                          <FormControl>
                             <InputLabel component="legend">{ETVConstants.trans("default_playtime")}</InputLabel>
                             <Select
                                 label={ETVConstants.trans("default_playtime")}
                                 id="default_keep_time_days"
                                 style={{ width: 200}}
                                 value={this.state.default_playtime}
                                 onChange={(e)=>{this.setState({default_playtime:e.target.value})}}>
                                 <MenuItem value={5}>{ETVConstants.trans("5_seconds")}</MenuItem>
                                 <MenuItem value={10}>{ETVConstants.trans("10_seconds")}</MenuItem>
                                 <MenuItem value={15}>{ETVConstants.trans("15_seconds")}</MenuItem>
                                 <MenuItem value={20}>{ETVConstants.trans("20_seconds")}</MenuItem>
                                 <MenuItem value={30}>{ETVConstants.trans("30_seconds")}</MenuItem>
                                 <MenuItem value={60}>{ETVConstants.trans("60_seconds")}</MenuItem>
                             </Select>
                           </FormControl>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("need_approval")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("need_approval_help")}</Typography>
                        </TableCell>
                        <TableCell>
                          <Switch checked={this.state.need_approval} color='primary' onChange={(e)=>{this.setState({need_approval:!this.state.need_approval})}} />
                        </TableCell>
                      </TableRow>

                      {/*
                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("show_overlay")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("show_overlay_help")}</Typography>
                        </TableCell>
                        <TableCell>
                          <Switch checked={this.state.show_image_overlay} color='primary' onChange={(e)=>{this.setState({show_image_overlay:!this.state.show_image_overlay})}} />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("accept_movies")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("accept_movies_help")}</Typography>
                        </TableCell>
                        <TableCell>
                          <Switch checked={this.state.accept_movies} color='primary' onChange={(e)=>{this.setState({accept_movies:!this.state.accept_movies})}} />
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <Typography component={'span'} variant="body1">
                              <Box fontWeight='bold' display='inline'>{ETVConstants.trans("accept_texts")}</Box>
                          </Typography>
                          <Typography variant="body2">{ETVConstants.trans("accept_texts_help")}</Typography>
                        </TableCell>
                        <TableCell>
                          <Switch checked={this.state.accept_texts} color='primary' onChange={(e)=>{this.setState({accept_texts:!this.state.accept_texts})}} />
                        </TableCell>
                      </TableRow>
                      */}

                    </TableBody>
                  </Table>
          </TableContainer>

                <Divider sx={{my:3}}/>
                <Typography style={{marginTop:20}} variant="h5">{ETVConstants.trans("accepted_senders")}</Typography>
                <Typography style={{marginTop:10}} variant="body1">{ETVConstants.trans("accepted_senders_help")}</Typography>
                <Box sx={{mt:2,maxWidth:760}}>
                  <ETVTable data={this.state.contacts} columns={contactsData} pageSize={5} search />
                </Box>
                <Button color='primary' startIcon={<PersonAddIcon/>} sx={{mt:2}} variant='outlined' onClick={()=>{this.showAddContact()}}>{ETVConstants.trans("add_contact")}</Button>

          <ETVMessagePopup
            type={this.state.info_type}
            open={this.state.window === 'message_div'}
            onClose={()=>{this.closeInfoMessage()}}
            title={this.state.info_title}
            message={this.state.info_message}
            allowClose={!this.state.spinning}
          />

          <div id='select_screens_div' style={{display:this.state.window==='select_screens_div'?'block':'none'}}>
                <SelectAvailableScreensNew isOpen={this.state.window==='select_screens_div'} user_id={this.props.user_id} closeHook={this.closeScreenSelection} selectedScreens={this.selectedScreens} selected={this.state.device_ids?this.state.device_ids:[]}/>
          </div>

          <ETVPopup
            open={this.state.window==='add_contact_div'}
            onClose={()=>this.setState({window:''})}
            width="small"
            icon={<PersonAddIcon/>}
            title={ETVConstants.trans('add_accepted_sender')}
            bottomActions={<><ETVActionButton action="cancel" label={ETVConstants.trans('close')} onClick={()=>this.setState({window:''})}/><ETVActionButton action="save" label={ETVConstants.trans('add')} onClick={()=>this.saveNewContact()}/></>}
          >
              <Table>
                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} width="50%">
                    <Typography variant="body1">
                      <Box fontWeight="bold" display="inline">
                        {ETVConstants.trans("email")}
                      </Box>
                    </Typography>
                    <Typography variant="body1">
                      {ETVConstants.trans("email_help")}
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'none' }}>
                    <TextField
                      required
                      type="email"
                      fullWidth
                      error={this.state.contact_id_error}
                      helperText={
                        this.state.contact_id_error
                          ? ETVConstants.trans("invalid_email")
                          : ""
                      }
                      value={this.state.new_contact_id}
                      onChange={(e) =>
                        this.setState({
                          new_contact_id: e.target.value,
                          contact_id_error: false
                        })
                      }
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell sx={{ borderBottom: 'none' }} width="50%">
                    <Typography variant="body1">
                      <Box fontWeight="bold" display="inline">
                        {ETVConstants.trans("display_name")}
                      </Box>
                    </Typography>
                  </TableCell>
                  <TableCell sx={{ borderBottom: 'none' }}>
                    <TextField
                      required
                      fullWidth
                      error={this.state.contact_name_error}
                      helperText={
                        this.state.contact_name_error
                          ? ETVConstants.trans("messaging_contact_name_helper")
                          : ""
                      }
                      value={this.state.new_contact_name}
                      onChange={(e) =>
                        this.setState({
                          new_contact_name: e.target.value,
                          contact_name_error: false
                        })
                      }
                    />
                  </TableCell>
                </TableRow>
              </Table>
          </ETVPopup>

        </ETVPage>
      )
    }
}

export default MessagingAdapter;
